// Tenant dial-code context for phone inputs.
//
// `<Input variant="phone">` needs a country to pre-select in its dial-code
// dropdown. Left alone it assumes India (+91), which is wrong for every GCC
// tenant — the reported symptom on the supplier form. The tenant's country is
// derived from its immutable currency via the frozen CURRENCY_COUNTRY table in
// `@bbpos/types`, the same mapping the tax regime and country display already
// use, so there is exactly one currency → country source in the codebase.
//
// Returns '+91' before the auth profile hydrates (useTenantCurrency defaults to
// INR), which keeps every INR tenant byte-identical. `Input` adopts the real
// dial once it arrives — see the late-hydration regression test in apps/pos.

import { getCountryForCurrency } from '@bbpos/types';

import { useTenantCurrency } from './use-tenant-currency';

/** Hook: the dial code for the current tenant's country, e.g. '+968' for Oman. */
export function useTenantDial(): string {
  return getCountryForCurrency(useTenantCurrency()).dial;
}
